export const Circle = () => {
  return (
    <div className="loader scale">
      <svg viewBox="0 0 80 80">
        <circle cx="40" cy="40" r="32"></circle>
      </svg>
    </div>
  )
}

export const Triangle = () => {
  return (
    <div className="loader triangle scale">
      <svg viewBox="0 0 86 80">
        <polygon points="43 8 79 72 7 72"></polygon>
      </svg>
    </div>
  )
}

export const Square = () => {
  return (
    <div className="loader scale">
      <svg viewBox="0 0 80 80">
        <rect x="8" y="8" width="64" height="64"></rect>
      </svg>
    </div>
  )
}
